export * from './queries/usePartnerConsentUserConsentQuery';
export * from './queries/useUserAgreementQueries';
